import * as ACTION_TYPES from '../constants/ACTION_TYPES';
import * as PAGINATION from '../constants/PAGINATION';

interface IPagination {
  create: (list: any[], size: number) => CreatePaginationAction;
  delete: () => DeletePaginationAction;
  setPageSize: (size: number) => SetPageSizeAction;
  jumpToPage: (page: number) => JumpToPageAction;
}

/**
 * To create a pagination for a `list`,
 * 1. Pass a unique key.
 * 2. Implement `IPagination`.
 */
export const DataItemPagination: IPagination = {
  create: (list: DataItem[], size: number) =>
    createPagination(PAGINATION.DATA_ITEM, list, size),
  delete: () => deletePagination(PAGINATION.DATA_ITEM),
  setPageSize: (size: number) => setPageSize(PAGINATION.DATA_ITEM, size),
  jumpToPage: (page: number) => jumpToPage(PAGINATION.DATA_ITEM, page),
};

export const ShopItemPagination: IPagination = {
  create: (list: ShopItem[], size: number) =>
    createPagination(PAGINATION.SHOP_ITEM, list, size),
  delete: () => deletePagination(PAGINATION.SHOP_ITEM),
  setPageSize: (size: number) => setPageSize(PAGINATION.SHOP_ITEM, size),
  jumpToPage: (page: number) => jumpToPage(PAGINATION.SHOP_ITEM, page),
};

export const ShopItemCategoryPagination: IPagination = {
  create: (list: ShopItemCategory[], size: number) =>
    createPagination(PAGINATION.SHOP_ITEM_CATEGORY, list, size),
  delete: () => deletePagination(PAGINATION.SHOP_ITEM_CATEGORY),
  setPageSize: (size: number) =>
    setPageSize(PAGINATION.SHOP_ITEM_CATEGORY, size),
  jumpToPage: (page: number) => jumpToPage(PAGINATION.SHOP_ITEM_CATEGORY, page),
};

/**
 * Abstract methods. Extend these.
 */
const createPagination = (
  key: string,
  list: any[],
  size: number
): CreatePaginationAction => ({
  type: ACTION_TYPES.PAGINATION_CREATE,
  payload: {
    key,
    list,
    size,
  },
});

const deletePagination = (key: string): DeletePaginationAction => ({
  type: ACTION_TYPES.PAGINATION_DELETE,
  payload: {
    key,
  },
});

const setPageSize = (key: string, size: number): SetPageSizeAction => ({
  type: ACTION_TYPES.PAGINATION_SET_SIZE,
  payload: {
    key,
    size,
  },
});

const jumpToPage = (key: string, page: number): JumpToPageAction => ({
  type: ACTION_TYPES.PAGINATION_JUMP_TO_PAGE,
  payload: {
    key,
    page,
  },
});



// WEBPACK FOOTER //
// ./app/actions/PaginationActionCreators.ts